var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 60C47.0685 60 60.5 46.5685 60.5 30C60.5 13.4315 47.0685 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 46.5685 13.9315 60 30.5 60Z",
    fill: "#FFD200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1441 30.6441C1.1441 14.0745 14.5745 0.644101 31.1441 0.644101C39.265 0.644101 46.6286 3.87041 52.0309 9.11315C46.5793 3.49323 38.9487 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 38.4487 3.99323 46.0793 9.61315 51.5309C4.37331 46.1286 1.1441 38.765 1.1441 30.6441Z",
    fill: "#FDF8EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6411 58.8714C48.4303 56.118 56.1914 48.528 59.174 38.8404L32.8964 12.5629L29.3829 36.9052L33.4883 41.0106L27.5086 47.0251L38.6411 58.8714Z",
    fill: "url(#paint0_linear_1564_30797)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2754 43.999C26.2754 42.8124 26.6874 41.8114 27.5085 40.9961C28.3325 40.1808 29.3276 39.7747 30.4998 39.7747C31.669 39.7747 32.6671 40.1866 33.4882 41.0077C34.3121 41.8317 34.7212 42.8269 34.7212 43.999C34.7212 45.1712 34.3063 46.175 33.4766 47.0135C32.6468 47.852 31.6545 48.2698 30.4998 48.2698C29.3276 48.2698 28.3325 47.8549 27.5085 47.0251C26.6874 46.1953 26.2754 45.1857 26.2754 43.999ZM34.2976 31.5406C34.2976 33.4381 33.9843 34.8482 33.3605 35.765C32.7367 36.6818 31.7822 37.1402 30.5027 37.1402C29.2377 37.1402 28.2889 36.676 27.6535 35.7505C27.021 34.8249 26.7048 33.4207 26.7048 31.5377V17.2514C26.7048 15.4004 27.021 14.0164 27.6535 13.0996C28.286 12.1828 29.2348 11.7244 30.5027 11.7244C31.7822 11.7244 32.7367 12.1799 33.3605 13.088C33.9843 13.999 34.2976 15.3859 34.2976 17.2514V31.5406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1564_30797",
    x1: 29.34,
    y1: 29.2904,
    x2: 51.345,
    y2: 51.2954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.542562b0ab8295c7c9b8401cff9432b1.svg";
export { ForwardRef as ReactComponent };